"use client";

import { useSyncExternalStore } from "react";
import { NOTIFICATIONS_REFETCH_INTERVAL_MS } from "@/features/notifications/constants";

function subscribeVisibility(onStoreChange: () => void) {
  if (typeof document === "undefined") return () => {};
  document.addEventListener("visibilitychange", onStoreChange);
  return () => document.removeEventListener("visibilitychange", onStoreChange);
}

function getVisibilitySnapshot() {
  return typeof document === "undefined"
    ? true
    : document.visibilityState === "visible";
}

/** Pause notification polling while the tab is hidden. */
export function useNotificationsRefetchInterval(
  intervalMs: number | false = NOTIFICATIONS_REFETCH_INTERVAL_MS,
): number | false {
  const isVisible = useSyncExternalStore(
    subscribeVisibility,
    getVisibilitySnapshot,
    () => true,
  );

  if (intervalMs === false || !isVisible) return false;
  return intervalMs;
}
